import React from 'react'
import Brand from '../Brand/Brand.js'
import styles from "./brandsContainer.module.scss"

export default function BrandsContainer (props) {
	const brands = [{
		name: 'Land Rover',
		color: '#005A2C',
		imageName: 'landrover'
	},
	{
		name: 'Jet2.com',
		color: '#ee3123',
		imageName: 'jet2'
	},
	{
		name: 'Jet2holidays',
		color: '#3d8ede',
		imageName: 'jet2holidays'
	},
	{
		name: 'Jaguar',
		color: '#9e1b32',
		imageName: 'jaguar'
	}]
	return (
		<div className={styles.container}>
			<div className={styles.inner}>
				<div className={styles.info}>
					<h4 className={styles.title}>Brands I've worked with</h4>
				</div>
				<div className={styles.brands}>
					{brands.map( (brand, index) => {
						return <Brand key={index} brand={brand} />
					})}
				</div>
			</div>
		</div>
	)
}



// WEBPACK FOOTER //
// ./src/components/BrandsContainer/BrandsContainer.js